import React, {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {getCookie, loadScriptsSequentially} from '../utils';
import {useModal} from '../backend/ModalContext';
import './LandingPage2.css';

function PartnerFinanziario() {
    // const [sites, setSites] = useState([]);
    const [faqCategories, setFaqCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState(null);
    const {openModal} = useModal(); // Usa la funzione per aprire il modal


    useEffect(() => {
        // Carica jQuery e altri script necessari
        const script = document.createElement('script');
        script.src = "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" + Date.now();
        script.onload = () => {
            loadScriptsSequentially([
                "js/pre-loader.js",
                "assets/bootstrap/js/popper.min.js",
                "assets/bootstrap/js/bootstrap.min.js",
                "js/parallaxie.js",
                "js/TweenMax.min.js",
                "js/jquery.wavify.js",
                "assets/wow/wow.min.js",
                "assets/counterup/jquery.counterup.min.js",
                "assets/counterup/jquery.waypoints.min.js",
                "js/main.js",
            ]);
        };

        document.body.appendChild(script);

        // Fetch FAQs from API
        fetch('https://psicopatici.com/api/v1/faqs/categories')
            .then(response => response.json())
            .then(data => {
                setFaqCategories(data.data);
                setLoading(false);
                setActiveCategory(6);
            })
            .catch(error => {
                console.error('Error fetching FAQs:', error);
                setLoading(false);
            });

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const handleCategoryClick = (categoryId) => {
        setActiveCategory(categoryId);
    };

    return (
        <>
            <section style={{marginTop: "100px"}} className="">
                <div className="container">
                    <div className="section_title text-center">
                        <h1 style={{fontWeight: "600"}} className=" fw-bolder">INVESTI IN PSICOPATICI ITALIA</h1>
                        <h4>Un brand nuovo, in forte e continua espansione.</h4>
                    </div>
                </div>
            </section>

    <section className="how-it-works">
        <div className="container">
          <h2>Vantaggi</h2>
          <div className="cards-container">
            <div className="card1">
              <p>
              Le opportunità di oggi potrebbero non essere le stesse di domani
              </p>
            </div>
            <div className="card1">
              <p>
              Brand giovanile e dinamico
              </p>
            </div>
            <div className="card1">
              <p>
              Idea rivoluzionaria nel settore della moda
              </p>
            </div>
            <div className="card1">
              <p>
              Diverse modalità di investimento 
              </p>
            </div>
            <div className="card1">
              <p>
              Investimento iniziale a tua discrezione
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <div className="container">
          <h2>Requisiti</h2>
          <div className="cards-container">
          <div className="media-body">
                <h4>Devi solo credere in noi, siamo sicuri di non deluderti!</h4>
            </div>
          </div>
        </div>
      </section>


            <section style={{paddingLeft: "2%", paddingRight: "2%"}} className='container mb-5 mt-5'>
                <link href="https://campaign.huberway.com/core/css/embedded.css" rel="stylesheet" type="text/css" /><link href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined" rel="stylesheet" />
                <div class="subscribe-embedded-form">
                    <h2 style={{color: "black"}} class="mt-0 text-center h_title wow fadeInUp">Richiedi Informazioni</h2>
                    <form action="https://campaign.huberway.com/lists/67b490af89c26/embedded-form-subscribe-captcha" method="POST" class="form-validate-jqueryz" novalidate="novalidate">
                        <div class="form-group control-text">
                            <label> Nome e Cognome <span class="text-danger">*</span></label><input id="NAME" placeholder="" type="text" name="NAME" class="form-control required" />
                        </div>
                        <div class="form-group control-text">
                            <label> Email <span class="text-danger">*</span></label><input id="EMAIL" placeholder="" type="text" name="EMAIL" class="form-control required email:rfc,filter" />
                        </div>
                        <div class="form-group control-text">
                            <label> Recapito Telefonico <span class="text-danger"></span></label><input id="PHONE" placeholder="" type="text" name="PHONE" class="form-control" />
                        </div>
                        <div class="form-button text-center"><button class="action_btn">Invia</button></div>
                    </form>
                </div>
            </section>
        </>
    );
}
export default PartnerFinanziario;

